(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.galerieSwiper = {
    attach: function (context, settings) {
      once('galerieSwiper', '.paragraph--galerie .swiper-container', context).forEach(function (block) {
        var that = $(block);

        new Swiper($(block)[0], {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 20,
          navigation: {
            nextEl: '.paragraph--galerie .swiper-control-next',
            prevEl: '.paragraph--galerie .swiper-control-prev',
          },
          /*autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },*/
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
